module.exports = __webpack_public_path__ + "static/media/couple-stone.347f6f6b.svg";